import { useEffect, useState } from "react";
import { Score } from "../Components/Home/Score";
import { Tickets } from "../Components/Home/Tickets";
import { Loading } from "../Components/Loading/Loading";
import { redirectToLogin } from "../utils/auth";
import { useUser } from "../context/UserContext";

// Internal-only RCS Support queue — same UI as the JBM dashboard, but lists all
// RCS-portal tickets (?portal=rcs) and uses the RCS config (?tag=rcs) so the
// severity/request-type labels resolve.
export const RcsSupport = () => {
  const [tickets, setTickets] = useState([]);
  const [dataLoading, setDataLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState("total");
  const [priorities, setPriorities] = useState([]);
  const [requestOptions, setRequestOptions] = useState([]);
  const [status, setStatus] = useState([]);
  const [count, setCount] = useState({});

  const { user } = useUser();
  const { username } = user;

  const authToken = localStorage.getItem("authToken");

  useEffect(() => {
    if (!authToken) {
      redirectToLogin();
      return;
    }

    const BASE = process.env.REACT_APP_BACKEND_URL;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    };

    const get = (url) =>
      fetch(url, { method: "GET", headers }).then((r) => {
        if (r.status === 401) {
          redirectToLogin();
          return null;
        }
        return r.json();
      });

    Promise.all([
      get(`${BASE}/API/V2/Tickets?portal=rcs`),          // RCS tickets
      get(`${BASE}/API/V2/config/priorities?tag=rcs`),   // RCS severities
      get(`${BASE}/API/V2/config/requesttypes?tag=rcs`), // RCS request types
      get(`${BASE}/API/V2/config/status`),               // shared statuses
    ])
      .then(([ticketsData, prioritiesData, requestTypesData, statusData]) => {
        if (!ticketsData || !prioritiesData || !requestTypesData || !statusData) return;

        if (ticketsData.error) {
          alert("Internal Server Error");
          return;
        }

        setTickets(ticketsData);
        setPriorities(prioritiesData);
        setRequestOptions(requestTypesData);
        setStatus(statusData);
        setDataLoading(false);
      })
      .catch((err) => console.log(err));
  }, []);

  if (dataLoading || !user.loaded) {
    return <Loading />;
  }

  return (
    <div className="flex flex-col p-6 gap-2">
      <Score
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
        count={count}
        status={status}
      />

      <Tickets
        tickets={tickets}
        setCount={setCount}
        requestOptions={requestOptions}
        priorities={priorities}
        status={status}
        activeIndex={activeIndex}
        isPartner={false}
        username={username}
        portal="rcs"
      />
    </div>
  );
};
